import VideoComp from "../videoComp/videoComp";
import ShopComp from "../shopComp/shopComp";
import ImgComp from "../imgComp/imgComp";
import Navigation from "../navigation/navigation";

//ASSETS

import oval from "../../videos/oval.mp4";

import img1 from "../../images/shopComp/comp5/img1.webp";
import img2 from "../../images/shopComp/comp5/img2.webp";
import img3 from "../../images/shopComp/comp5/img3.webp";
import img4 from "../../images/shopComp/comp5/img4.webp";

import Img_5 from "../../images/imgComp/imgComp5.webp";
import imgBg5 from "./images/bgs/oval.webp";

export default function FourthComp() {
  return (
    <>
      {/* <div className="allow-scroll demo"> */}
      {/* <Navigation /> */}

      <VideoComp
        id={5}
        header={"O reinterpretare a stilului clasic"}
        idHeader={"the oval"}
        text={
          <>
            <p>
              Cu un design alungit, <br /> diamantele <b>Oval Cut</b> te vor
              cuceri prin conturul elegant și suplu.
            </p>
            <p>
              {" "}
              Această formă este ideală pentru femeia atrasă de creativ și
              neconvențional, care pășește mereu în avangarda modei,
              păstrându-și totodată aerul elegant și clasic.
            </p>
          </>
        }
        // videoBg={imgBg5}
        videoBg={<img src={imgBg5} alt="" />}
        vidLink={oval}
        href={
          "https://www.teilor.com/18k-white-gold-engagement-ring-with-0-8ct-and-0-452ct-diamonds-119585.html"
        }
        buttonText={"View the ring"}
      />
      <ShopComp
        ring_1={img1}
        href_1={
          "https://www.teilor.ro/inel-de-logodna-din-aur-alb-de-18k-cu-diamant-de-0-3ct-106571.html"
        }
        ring_2={img2}
        href_2={
          "https://www.teilor.ro/lant-cu-pandant-din-aur-alb-de-18k-cu-diamant-de-0-3ct-119480.html"
        }
        ring_3={img3}
        href_3={
          "https://www.teilor.ro/cercei-din-aur-galben-de-18k-cu-diamante-de-0-8ct-106456.html"
        }
        ring_4={img4}
        href_4={
          "https://www.teilor.ro/inel-din-aur-alb-de-18k-cu-diamant-de-0-11ct-si-diamante-de-0-14ct-33171.html"
        }
        // mainLink={"https://www.teilor.ro/perpetual-love.html"}
      />
      <ImgComp
        img={Img_5}
        bgProp={"shape-5-bg"}
        // shape={<img className="shape-5" src={Svg_5}></img>}
        rightText1={<span style={{ color: "#B4B4B4" }}>Iubitoare</span>}
        rightText2={<span style={{ color: "#797979" }}>Nonconformistă</span>}
        leftText1={<span style={{ color: "#484848" }}>Creativă </span>}
        leftText2={<span style={{ color: "#B4B4B4" }}>Plină de viață</span>}
        mainLink={"https://www.teilor.com/perpetual-love.html"}
      />
      {/* </div> */}
    </>
  );
}
